/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ButtonProps, DIALOG_SIZE_SM_MD, DIALOG_TYPE_WIZARD, DialogProps } from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogLauncher } from '../../../../Components/DialogLauncher/DialogLauncher';
import { CORE_STRINGS } from '../../../../Constants/Strings.constants';
import { SETTING_LIST_DATA_IDS } from '../../SettingList.constants';
import { getSettingCreationSteps } from '../../utils/GetSettingCreationSteps/GetSettingCreationSteps';
import { hasSettingCreatePermission } from '../../utils/HasSettingCreatePermission/HasSettingCreatePermission';
import { SettingCreateProps } from './SettingCreate.props';

/**
 * The setting create dialog launcher.
 */
export const SettingCreate = (props: SettingCreateProps): JSX.Element => {
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      createSetting: t(CORE_STRINGS.createSetting),
    };
  }, [t]);

  const buttonProps: ButtonProps = {
    disabled: !hasSettingCreatePermission(),
    text: labels.createSetting,
  };

  const wizardProps: DialogProps = {
    dialogSize: DIALOG_SIZE_SM_MD,
    dialogType: DIALOG_TYPE_WIZARD,
    heading: labels.createSetting,
    scrollOnOverflow: true,
    showDividers: true,
    stateHandler: useDialogStore,
    wizardSteps: getSettingCreationSteps(props),
  };

  return (
    <div className="service-settings-create" data-id={SETTING_LIST_DATA_IDS.createSettingButton}>
      <DialogLauncher buttonProps={buttonProps} dialogProps={wizardProps} />
    </div>
  );
};
